var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.81958 13.4965L13.9951 8.19708",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.663 3.99859L5.05561 9.72055C4.80574 9.9705 4.66537 10.3095 4.66537 10.6629C4.66537 11.0163 4.80574 11.3553 5.05561 11.6052C5.30556 11.8551 5.64452 11.9955 5.99794 11.9955C6.35137 11.9955 6.69033 11.8551 6.94027 11.6052L12.5476 5.88325C13.0474 5.38335 13.3281 4.70544 13.3281 3.99859C13.3281 3.29173 13.0474 2.61382 12.5476 2.11392C12.0477 1.61418 11.3698 1.33344 10.663 1.33344C9.9561 1.33344 9.27818 1.61418 8.77829 2.11392L3.17028 7.83522C2.42034 8.58517 1.99902 9.60231 1.99902 10.6629C1.99902 11.7235 2.42034 12.7406 3.17028 13.4905C3.92022 14.2405 4.93736 14.6618 5.99794 14.6618C7.05852 14.6618 8.07566 14.2405 8.8256 13.4905",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.594dc193f68f2e5a164882953356b86c.svg";
export { ForwardRef as ReactComponent };